import { createRefresh } from "react-auth-kit"
import { getTokenExpiration } from "./token"
import { AUTH_KEY } from "../consts/auth"
import {
  refreshToken as doRefreshToken,
} from "../sign-in/SignIn.state"

const getRefreshApi = (props) => {
  const { signInKey } = props || {}
  let currentAuthState = {}
  let interval = 10

  try {
    // retrieve the token directly from the local storage
    // because it can't access the auth store yet.
    const authState = localStorage.getItem(`${AUTH_KEY}_state`)
    if (authState) {
      interval = getTokenExpiration(authState)?.interval
      currentAuthState = JSON.parse(authState)
    }
  } catch {}

  return createRefresh({
    interval,
    refreshApiCallback: ({ authToken, refreshToken }) => doRefreshToken({
        authToken,
        refreshToken,
        isRefresh: true,
        currentAuthState,
        signInKey,
    }),
  })
}

export default getRefreshApi
